export default __webpack_public_path__ + "static/media/wood.aaa5cb87.jpg";